<template>
  <div class="miya-checkList">
    <div class="item" v-for="(item, idx) in list" :key="'miyacheck'+idx" @click.stop="clickItem(item)" :class="{active: isChecked(item)}">
      <p class="check-name">{{item.name}}</p>
      <i class="el-icon-check" v-if="isChecked(item)"></i>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      checkList: [],
    }
  },
  props: {
    list: {
      type: Array, // name显示内容  value选中后的传值
      default: () => {return []}
    },
    default: {
      type: Array,
      default: () => {return []}
    },
    isMut: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (this.isMut) {
      this.default.map(item => {
        let obj = this.list.find(val => {return val.value === item.name})
        if (obj) {
          this.checkList = [JSON.parse(JSON.stringify(obj))]
        }
      })
    } else {
      let obj = this.list.find(val => {return val.value === this.default[0]})
      if (obj) {
        this.checkList = [JSON.parse(JSON.stringify(obj))]
      }
    }
  },
  methods: {
    isChecked (item) {
      return this.checkList.findIndex(val => {return val.value === item.value}) >= 0
    },
    clickItem (item) {
      if (this.isMut) {
        let idx = this.checkList.findIndex(val => {return val.value === item.value})
        if (idx >= 0) {
          this.checkList.splice(idx, 1)
        } else {
          this.checkList.push(JSON.parse(JSON.stringify(item)))
        }
      } else {
        this.checkList = [JSON.parse(JSON.stringify(item))]
      }
      this.$emit('change', this.checkList)
    },
  }
}
</script>
<style scoped lang="stylus">
.miya-checkList
  display flex
  flex-wrap wrap
  margin-bottom -12px
  .item
    margin-right 20px
    width 140px
    background-color #F5F6F7
    border 1px solid $c4
    line-height 34px
    text-align center
    position relative
    font-size $f14
    cursor pointer
    margin-bottom 12px
  .active
    color $c8
    fontWeight()
    border 1px solid $c8
    background-color $c81
    overflow hidden
    &:before
      content ''
      position absolute
      bottom -15px
      left -15px
      z-index 1
      display block
      border 15px solid transparent
      border-right 15px solid $c8
      transform rotate(-45deg)
    .el-icon-check
      position absolute
      fontWeight()
      font-size $f12
      bottom -2px
      left 0
      color $c7
      z-index 2
</style>